import React from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import apiDecorator from 'api/api-decorator';
import { emit } from 'helpers/global-events';
import Button from 'components/button';
import { iconTypes } from 'components/icon';
import Notification from 'components/notification';

import 'styles/forum/common/admin/panel/_admin-panel-forum.scss';

const bemClassesPostControl = new Bem('postControlForum');

@apiDecorator
export default class ComplaintsButtonChecked extends React.PureComponent {
  static propTypes = {
    postId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ])
  };

  constructor(...args) {
    super(...args);
    this.checkPostComplaint = this.checkPostComplaint.bind(this);
  }

  /**
   * Set status check as checked in DB.
   */
  checkPostComplaint(postId) {
    this.api.post('action/forum/actions-check-status-complaint/checked', {
      postData: {
        postId
      }
    })
      .then(() => {
        Notification.success('Жалобы успешно проверены.');
        emit('updateClubPosts');
        emit('updatePosts');
        emit('updateTreeComplaint', { $action: 'fullUpdate' });
      });
  }

  render() {
    const { postId } = this.props;

    return (
      <Button
        {...bemClassesPostControl('btn', 'del')}
        onClick={() => this.checkPostComplaint(postId)}
        iconType={iconTypes.check}
        title="Жалобы проверены"
      />
    );
  }
}
